// @ts-nocheck: converted from JS

import Button from '@/components/UI/Button';
import { DateTimeRenderer } from '@/components/UI/DateRenderers/DateRenderers';
import { renderMetadataValue } from '@/helpers';

const generateMetadataColumns = (linkMetadata, columns) =>
  linkMetadata?.map((meta) => {
    return {
      id: `metadata.${meta.slug}`,
      accessorFn: (row) => row.metadata?.[meta.slug],
      header: meta.title,
      headerClassName: 'no-sort',
      enableSorting: false,
      isVisible: columns?.[`metadata.${meta.slug}`] ?? false,
      cell: ({ row }) => {
        const metadataItem = { ...meta, value: row.original.metadata?.[`${meta.slug}`] };
        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
        if (metadataItem?.value) {
          return renderMetadataValue(metadataItem);
        }
        return false;
      },
    };
  });

export const initialColumns = (downloadFile, context, setLoading, metadata, columns) => [
  {
    id: 'name',
    header: 'Name',
    accessorKey: 'name',
    enableSorting: true,
    cell: ({ row }) => (
      <Button
        onClick={() => {
          downloadFile({ context, name: row.original.name, setLoading });
        }}
        stateless
        className="link blue ph0"
      >
        {row.original.name}
      </Button>
    ),
    isVisible: columns?.['name'] ?? true,
  },
  {
    id: 'created',
    header: 'Created',
    enableSorting: true,
    cell: ({ row }) => <DateTimeRenderer value={row.original.metadata.created_at} />,
    isVisible: columns?.['created'] ?? true,
  },
  {
    id: 'updated',
    header: 'Updated',
    enableSorting: true,
    cell: ({ row }) => <DateTimeRenderer value={row.original.metadata.last_modified_at} />,
    isVisible: columns?.['updated'] ?? true,
  },
  {
    id: 'created_by',
    header: 'Created By',
    accessorFn: (row) => row.metadata?.created_by,
    enableSorting: true,
    isVisible: columns?.['created_by'] ?? true,
  },
  ...generateMetadataColumns(metadata, columns),
];
